/**
 * Applies offer-line recursion guard after inline builder logic (may be page-cached).
 * Loaded synchronously from layout + builder section so it runs before DOMContentLoaded init.
 */
(function (global) {
  'use strict';
  var resolver = global.PBOfferLineResolver;
  if (resolver && typeof resolver.patchProductBuilderOfferLineGuards === 'function') {
    resolver.patchProductBuilderOfferLineGuards(global.productBuilder);
  }
})(typeof window !== 'undefined' ? window : globalThis);
